import {
  ApiTokenListResponse,
  CalendarEventOccurrence,
  TokenPageableRequestParams,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { tokenPagination } from "../../tokenPagination";

const keys = {
  all: () => ["staffApiEventOccurrence"] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
};

export const staffApiEventOccurrence = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params: {
        dateFrom?: string;
        dateTo?: string;
        includeBookedCounts?: boolean;
        includeWaitingCounts?: boolean;
        eventHostId?: string[];
        facilityId?: number[];
        activityId?: number[];
        isPublicEvent?: boolean;
        activityCategoryId?: number[];
      } & TokenPageableRequestParams,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiTokenListResponse<CalendarEventOccurrence>>(
              "/calendar/event-occurrences",
              {
                params: {
                  ...params,
                  nextPageToken: pageParam,
                },
              },
            )
          ).data;
        },
        ...tokenPagination,
      }),
  },
  mutations: {},
};
